import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, StyleGuide } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = StyleGuide[];

export const useStyleGuides = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query styleGuides($id: ID) {
      clientAccount {
        styleGuides(id: $id) {
          id
          name
          updatedAt
          approved
          referenceId
          availableLanguages
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useStyleGuides'],
    queryFn: async () => {
      const response: ClientAccount = await client.request({
        data: {
          gql: graphql
        }
      });

      return response?.styleGuides ?? [];
    }
  });
};
